var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup6520(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.935,
    height: 27.935,
    viewBox: "0 0 27.935 27.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-534.353 -165.745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.993,169.745a11.64,11.64,0,1,0,11.64,11.64A11.636,11.636,0,0,0,549.993,169.745Zm0,3.492a3.492,3.492,0,1,1-3.492,3.492A3.495,3.495,0,0,1,549.993,173.237Zm0,16.528a8.381,8.381,0,0,1-6.984-3.748c.029-2.31,4.662-3.585,6.984-3.585s6.949,1.275,6.984,3.585A8.381,8.381,0,0,1,549.993,189.765Z",
    transform: "translate(-1.672 -1.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M534.353,165.745h27.935V193.68H534.353Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6520);
export default __webpack_public_path__ + "static/media/Group 6520.d0f4b779fd42f35eb9d0559ff512aef2.svg";
export { ForwardRef as ReactComponent };